// extracted by mini-css-extract-plugin
export default {"rating":"GR-z","numberOfStars":"HR-z","count":"IR-z","barGraphSpacing":"JR-z","barGraph":"KR-z"};